import i18n from 'i18next';

import * as EN from '../../i18n/brand/en.json';
import * as FR from '../../i18n/brand/fr.json';
import * as ES from '../../i18n/brand/es.json';
import * as AR from '../../i18n/brand/ar.json';

/**
 * The Brand Portal's words (BRAND_PORTAL.*), added to the shared translation
 * bundle when the portal's code loads — at start-up, since the router imports
 * the pages and the rail imports this.
 *
 * Added here rather than in i18.instance.ts so the night's parallel work does
 * not all edit that file's one long line per language; moving these four
 * bundles into the instance's spread is a mechanical change if preferred.
 * Waits for the instance to initialise rather than importing it, so modules
 * that load this under test (with react-i18next mocked) are not affected.
 */
const bundles: Record<string, any> = { en: EN, fr: FR, es: ES, ar: AR };

function register() {
    for (const [lang, bundle] of Object.entries(bundles)) {
        i18n.addResourceBundle(lang, 'translation', (bundle as any).default ?? bundle, true, false);
    }
}

if (i18n.isInitialized) register();
else i18n.on('initialized', register);

export {};
